"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MessageType_1 = require("./MessageType");
var JoinErrorMessage = (function () {
    function JoinErrorMessage(payload) {
        this.t = MessageType_1.MessageType.JOIN_ERROR;
        this.d = payload;
    }
    return JoinErrorMessage;
}());
exports.JoinErrorMessage = JoinErrorMessage;
//# sourceMappingURL=JoinErrorMessage.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@utex/adonis-client/dist/messages/JoinErrorMessage.js
// module id = 1624
// module chunks = 118